var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_589_89708"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    rx: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg1_589_89709"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_589_89708)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg1_589_89709)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.333418046875,15.3336621875C15.333418046875,15.3336621875,15.333418046875,9.6669921875,15.333418046875,9.6669921875C15.333418046875,9.6669921875,16.666748046875,9.6669921875,16.666748046875,9.6669921875C16.666748046875,9.6669921875,16.666748046875,15.3336621875,16.666748046875,15.3336621875C16.666748046875,15.3336621875,22.333448046875,15.3336621875,22.333448046875,15.3336621875C22.333448046875,15.3336621875,22.333448046875,16.6669921875,22.333448046875,16.6669921875C22.333448046875,16.6669921875,16.666748046875,16.6669921875,16.666748046875,16.6669921875C16.666748046875,16.6669921875,16.666748046875,22.3336921875,16.666748046875,22.3336921875C16.666748046875,22.3336921875,15.333418046875,22.3336921875,15.333418046875,22.3336921875C15.333418046875,22.3336921875,15.333418046875,16.6669921875,15.333418046875,16.6669921875C15.333418046875,16.6669921875,9.666748046875,16.6669921875,9.666748046875,16.6669921875C9.666748046875,16.6669921875,9.666748046875,15.3336621875,9.666748046875,15.3336621875C9.666748046875,15.3336621875,15.333418046875,15.3336621875,15.333418046875,15.3336621875C15.333418046875,15.3336621875,15.333418046875,15.3336621875,15.333418046875,15.3336621875Z",
    fillRule: "evenodd",
    fill: "#4E5969",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 0,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#D9D9D9",
    fill: "none",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon_add.09979ece4bbed1dc1b64f70268d25593.svg";
export { ForwardRef as ReactComponent };